import posthog from 'posthog-js'

posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
  api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
  capture_pageleave: true,
  autocapture: {
    // Capture all interactive elements
    dom_event_allowlist: ['click', 'change', 'submit'],
    element_allowlist: ['a', 'button', 'form', 'input', 'select', 'textarea', 'label'],
    css_selector_allowlist: ['[data-track]', '[ph-capture]'],
    // Exclude sensitive elements
    element_attribute_ignorelist: ['aria-label', 'data-attr-pii'],
    capture_copied_text: true,
  },
  session_recording: {
    maskAllInputs: false,
    maskInputOptions: {
      password: true,
      search: false,
    },
  },
  debug: process.env.NODE_ENV === 'development',
})
